import { get, post, put, remove } from "./apiClient";

export default {
  async getLocationHierarchy(facilityId) {
    if (!facilityId) {
      throw new Error("Facility ID is required");
    }

    return await get(
      `location/${encodeURIComponent(facilityId)}/locationHierarchy`
    );
  },

  async addNewLocation(parentId, locationName) {
    return await post(
      `location/${encodeURIComponent(parentId)}/locations`,
      JSON.stringify(locationName)
    );
  },

  async getObservableLocations(facilityId) {
    return await get(
      `location/${encodeURIComponent(facilityId)}/observableLocations`
    );
  },

  async updateLocationName(locationId, locationName) {
    await put(
      `location/${encodeURIComponent(locationId)}/name`,
      JSON.stringify(locationName)
    );
  },

  async updateLocationObservationStatus(locationId, isObservable) {
    await put(
      `location/${encodeURIComponent(locationId)}/observationStatus`,
      isObservable
    );
  },

  async deleteLocation(locationId) {
    await remove(`location/${encodeURIComponent(locationId)}`);
  }
};
